export default __webpack_public_path__ + "static/hram-ikony-bozhiej-materi-sporitelnica-hlebov-krovlya_3-df1b78fb15d6b20e64455e02abd5bf31.jpg";